import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from './keys'
import {getSubscribedHostsV3} from '../services/recurringGift.http'
import {SubscriptionStatusesE} from '@/features/chat/chat.model'

type useFetchSubscribedHostsProps = {
    enabled: boolean
    status?: SubscriptionStatusesE
}
export const useGetSubscribedHostsV3 = ({enabled = true, status}: useFetchSubscribedHostsProps) => {
    return useQuery({
        queryKey: [QUERY_KEYS.subscribedHostsV3, enabled, status],
        queryFn: () => getSubscribedHostsV3(status ?? undefined),
        refetchOnMount: true,
        enabled
    })
}
